import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import cx from "classnames";
import { toolkitCx } from "../../../constants";
import { MoonIcon, SunIcon } from "../../../icons";
const themes = [
    {
        theme: "light",
        Icon: (props) => _jsx(MoonIcon, { ...props }),
    },
    {
        theme: "dark",
        Icon: (props) => _jsx(SunIcon, { ...props }),
    },
];
const ThemeSwitcher = ({ className, preferredTheme, toggleTheme, }) => {
    return (_jsx(_Fragment, { children: themes.map(({ Icon, theme }) => {
            if (preferredTheme !== theme)
                return null;
            return (_jsx(Icon, { className: cx("fill-current", toolkitCx.layout.text.default, className), onClick: toggleTheme }, theme));
        }) }));
};
export default ThemeSwitcher;
//# sourceMappingURL=ThemeSwitcher.js.map